// ─────────────────────────────────────────────────────────────
// PORTFOLIO PROJECTS — REAL MIRABILIS CLIENT PHOTOS
// ─────────────────────────────────────────────────────────────
// Photos pulled from mirabilisjoinery.com/our-work. If a photo
// belongs to a different project, just move its URL to the
// correct project's `images` array.
// ─────────────────────────────────────────────────────────────

const CDN =
  "https://storage.googleapis.com/msgsndr/XFavMTRXOcB6zlC9P1WM/media";

export const PROJECTS = [
  {
    title: "Mosman Headland",
    type: "Kitchen",
    audience: "homeowner",
    sub: "Single-storey villa kitchen",
    budget: "AUD 180–220k",
    time: "14 weeks",
    images: [
      `${CDN}/690dbc2d25530f03f3f9e48e.jpeg`,
      `${CDN}/690f1f775542ae2a0063c278.jpeg`,
      `${CDN}/690f1f5d0269a3f277e2d653.jpeg`,
    ],
  },
  {
    title: "Albert Park Terrace",
    type: "Kitchen + butler's pantry",
    audience: "homeowner",
    sub: "Heritage joinery throughout",
    budget: "AUD 240–280k",
    time: "18 weeks",
    images: [
      `${CDN}/690f1ff05542aefbd263ce45.jpeg`,
      `${CDN}/690f1b1eccf3493fa3ee99e0.jpeg`,
      `${CDN}/690dbfa525530f8ef0fa53cb.jpeg`,
    ],
  },
  {
    title: "Cottesloe Beach House",
    type: "Wardrobes + entertainment",
    audience: "homeowner",
    sub: "Full-home custom joinery",
    budget: "AUD 160–195k",
    time: "12 weeks",
    images: [
      `${CDN}/690f1f896fdbcab0f6841728.jpeg`,
      `${CDN}/690dbf1925530f69bbfa45d2.jpeg`,
      `${CDN}/690f20070269a39936e2e42d.jpeg`,
    ],
  },
  {
    title: "Hawthorn Hall",
    type: "Custom home",
    audience: "builder",
    sub: "Builder package — 6 rooms",
    budget: "AUD 320–380k",
    time: "22 weeks",
    images: [
      `${CDN}/690f1fb66fdbcaaec5841ae9.jpeg`,
      `${CDN}/690f1ff05542aefbd263ce45.jpeg`,
      `${CDN}/690f1f775542ae2a0063c278.jpeg`,
    ],
  },
  {
    title: "Noosa Ridge Duplex",
    type: "Duplex",
    audience: "builder",
    sub: "Two homes, one program",
    budget: "AUD 290–340k",
    time: "16 weeks",
    images: [
      `${CDN}/690dbf1925530f69bbfa45d2.jpeg`,
      `${CDN}/690f20070269a39936e2e42d.jpeg`,
      `${CDN}/690dbfa525530f8ef0fa53cb.jpeg`,
    ],
  },
  {
    title: "Parramatta Rise",
    type: "Multi-unit · 24 apartments",
    audience: "builder",
    sub: "Apartment kitchen package",
    budget: "AUD 1.4–1.8m",
    time: "9 months",
    images: [
      `${CDN}/690f1b1eccf3493fa3ee99e0.jpeg`,
      `${CDN}/690dbc2d25530f03f3f9e48e.jpeg`,
      `${CDN}/690f1fb66fdbcaaec5841ae9.jpeg`,
    ],
  },
  {
    title: "Surry Hills Workplace",
    type: "Commercial fit-out",
    audience: "builder",
    sub: "Office + cafe joinery",
    budget: "AUD 420–490k",
    time: "11 weeks",
    images: [
      `${CDN}/690f1f5d0269a3f277e2d653.jpeg`,
      `${CDN}/690f1f896fdbcab0f6841728.jpeg`,
      `${CDN}/690f1ff05542aefbd263ce45.jpeg`,
    ],
  },
];
